import React from "react"
import { Box, Typography, Skeleton } from "@mui/material"
import { ReactComponent as ArticleCategory } from '../../../../assets/images/KnowledgeBase/article-category.svg'

const getColumns = (viewMode) => {
    switch (viewMode) {
        case "mobile": return 1;
        case "tab": return 2;
        default: return 3;
    }
};

const getFlexBasis = (viewMode) => {
    switch (viewMode) {
        case "mobile": return "0 0 100%";
        case "tab": return "0 0 calc(50% - 8px)";
        default: return "0 0 calc(33.333% - 12px)";
    }
};

export function BrowseCategory({ brandColor, accentColor, categories = [], loading, viewMode = "web", fontFamily }) {
    const isMobile = viewMode === "mobile";
    const flexBasis = getFlexBasis(viewMode);
    const columns = getColumns(viewMode);

    if (loading) {
        return (
            <Box>
                <Skeleton variant="text" width={isMobile ? 150 : 200} height={32} sx={{ mb: isMobile ? 2 : 3 }} />
                <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {Array.from({ length: columns }).map((_, item) => (
                        <Box
                            key={item}
                            sx={{
                                backgroundColor: "#FBFCFC",
                                borderRadius: 1,
                                border: "1px solid #E5E9EC",
                                p: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                minWidth: isMobile ? "100%" : 200,
                                height: isMobile ? 100 : 118,
                                flex: flexBasis,
                            }}
                        >
                            <Box sx={{ mb: 2, flexShrink: 0 }}>
                                <Skeleton variant="circular" width={32} height={32} />
                            </Box>
                            <Skeleton variant="text" width="60%" height={24} sx={{ mt: 1 }} />
                            <Skeleton variant="text" width="40%" height={20} />
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    }

    const validCategories = Array.isArray(categories) ? categories.filter(cat => !cat.parentId).slice(0, 6) : [];

    if (validCategories.length === 0) {
        return null;
    }

    return (
        <Box>
            <Typography
                sx={{
                    fontSize: isMobile ? 16 : 20,
                    fontWeight: 700,
                    color: "#0C141B",
                    mb: isMobile ? 2 : 3,
                    fontFamily: "Inter",
                    lineHeight: "normal",
                }}
            >
                Browse by Category
            </Typography>

            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                {validCategories.map((category) => (
                    <Box
                        key={category._id}
                        sx={{
                            backgroundColor: "#FBFCFC",
                            borderRadius: 1,
                            border: "1px solid #E5E9EC",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            minWidth: isMobile ? "100%" : 200,
                            height: isMobile ? 100 : 118,
                            flex: flexBasis,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            boxSizing: "border-box",
                            "&:hover": {
                                borderColor: brandColor,
                                boxShadow: `0 2px 8px ${brandColor}20`,
                            },
                        }}
                    >
                        <ArticleCategory />
                        <Typography
                            sx={{
                                fontSize: isMobile ? 12 : 14,
                                fontWeight: 700,
                                color: "#0C141B",
                                fontFamily: `${fontFamily || "Inter"} !important`,
                                mb: '11px',
                                mt: isMobile ? '14px' : '20px',
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                width: "100%"
                            }}
                        >
                            {category.name}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 7,
                                color: accentColor || brandColor,
                                fontWeight: 600,
                                fontFamily: `${fontFamily || "Inter"} !important`,
                            }}
                        >
                            {category.articleCount || 0} ARTICLES
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
